import { useMutation } from "react-query";
import { UpdateSalesmanBonusRequest } from "./types";
import { axiosInstance } from "../../config/axios";

export const updateSalesmanBonus = async (data: UpdateSalesmanBonusRequest): Promise<any> => {
    const response = await axiosInstance.post("/SalesmanBonus/Patch", data);
    return response.data;
};

export function useUpdateSalesmanBonus() {
    return useMutation<any, Error, UpdateSalesmanBonusRequest>(
        (variables) => updateSalesmanBonus(variables)
    );
}
